import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const WalletIcons = ({ height, width, color }) => {
    return (
        <View>
            <Svg width={width} height={height} viewBox="0 0 24 24" fill="none">
                <Path
                    d="M4.5 6.5V6.5C4.5 5.39543 5.39543 4.5 6.5 4.5L17.9286 4.5C17.9949 4.5 18.0281 4.5 18.056 4.50314C18.2878 4.52926 18.4707 4.71221 18.4969 4.94402C18.5 4.97192 18.5 5.00509 18.5 5.07143V5.07143C18.5 5.46946 18.5 5.66848 18.4811 5.83589C18.3244 7.22675 17.2268 8.32442 15.8359 8.48114C15.6685 8.5 15.4695 8.5 15.0714 8.5H15"
                    stroke={color}
                />
                <Path
                    d="M4.5 6.5V6.5C4.5 7.60457 5.39543 8.5 6.5 8.5L17.5 8.5C18.4428 8.5 18.9142 8.5 19.2071 8.79289C19.5 9.08579 19.5 9.55719 19.5 10.5V12.5"
                    stroke={color}
                />
                <Path
                    d="M4.5 6.5L4.5 15.5C4.5 17.3856 4.5 18.3284 5.08579 18.9142C5.67157 19.5 6.61438 19.5 8.5 19.5L17.5 19.5C18.4428 19.5 18.9142 19.5 19.2071 19.2071C19.5 18.9142 19.5 18.4428 19.5 17.5V16.5"
                    stroke={color}
                />
                <Path
                    d="M19.5 16.5H17.5C16.5572 16.5 16.0858 16.5 15.7929 16.2071C15.5 15.9142 15.5 15.4428 15.5 14.5V14.5C15.5 13.5572 15.5 13.0858 15.7929 12.7929C16.0858 12.5 16.5572 12.5 17.5 12.5H19.5M19.5 16.5V12.5"
                    stroke={color}
                />
            </Svg>
        </View>
    );
};

export default WalletIcons;
